export default "__VITE_ASSET__X6NVCnML__"